import React, { FC } from 'react'
import { RegistrationPage } from '../components/register/RegistrationPage'

const RegistrationPageRoute: FC = () => {
  return <RegistrationPage />
}

export default RegistrationPageRoute
